module.exports = __webpack_public_path__ + "img/design-world.2297c38c.png";